// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2rD7G","vLegacy":"SelectSecondary_vLegacy__Y7DY1","error":"SelectSecondary_error__1Hw1V","disabled":"SelectSecondary_disabled__1jsNd"};